import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as Cookies from 'js-cookie';

import { AnalyticsService } from '../../services/analytics.service';
import { AuthCustomerService } from './auth-customer.service';
import { numericalInputOnly } from '../../utils/input-handler/numerical-input-only';
import { convertSecToMin } from '../../utils/transform-value/transform-seconds-to-minutes';

import { ERROR_AUTHENTICATION_MESSAGES } from '../../shared/constants/error-authentication-message.constant';
import {
  TNK_LOAN_SUCCESS_USER,
  TNK_OTP_SENDED,
  TNK_TOKEN,
} from '../../shared/constants/cookies-name.constant';
import { INPUT_TYPE, AUTH_TYPE, OTP } from './auth-customer.constant';
export class TNKAuthCustomerComponent implements OnInit {
public step: number;
public callbackURI: string;
public type: string;

  
  phoneNumber = new EventEmitter<string>();

  
  otp1Element: ElementRef;
  
  otp2Element: ElementRef;
  
  otp3Element: ElementRef;
  
  otp4Element: ElementRef;
public loginData: any;
public submitData: any;
public inputError: any;
public userSuccessData: any;
public submitValidation: any;
public isBusy: boolean = false;
public isVerificationSent: boolean = false;
public isChangePhoneNumber: boolean = false;
public isDisableButton: boolean = false;
public isLoginLimitExceeded: boolean;
public numericalInputOnly: any = numericalInputOnly;
public convertSecToMin: any = convertSecToMin;
public INPUT_TYPE = INPUT_TYPE;
public displayCountDown: string;
private countDownTime: number;
/**
 * @param {?} analyticsService
 * @param {?} authService
 */
constructor(
private analyticsService: AnalyticsService,
private authService: AuthCustomerService,
  ) {
    this.loginData = {
      phone: '',
      pin: '',
      otp_1: null,
      otp_2: null,
      otp_3: null,
      otp_4: null,
    };

    this.inputError = {
      phone: '',
      pin: '',
      otp: '',
    };

    this.submitValidation = {
      display: false,
      msg: '',
    };

    this.step = 1;

    this.submitData = {
      phone: '',
      identifier: '',
      smsToken: '',
      tokenId: '',
    };

    this.isLoginLimitExceeded = false;
    this.countDownTime = 60;
  }
/**
 * @return {?}
 */
ngOnInit() {
    if (this.type !== AUTH_TYPE.login) {
      this.autoLogin();
    }
  }
/**
 * @return {?}
 */
public autoLogin(): void {
    const /** @type {?} */ successUserLoanData = Cookies.get(TNK_LOAN_SUCCESS_USER);

    if (successUserLoanData) {
      this.userSuccessData = JSON.parse(successUserLoanData);
      this.phoneNumber.emit(this.userSuccessData.phoneNumber);
    }

    if (this.userSuccessData) {
      if (!Cookies.get(TNK_OTP_SENDED)) {
        this.submitKTP();
      }
    } else {
      location.href = this.callbackURI;
    }
  }
/**
 * @return {?}
 */
public changePhoneNumber(): void {
    this.isChangePhoneNumber = !this.isChangePhoneNumber;
  }
/**
 * @param {?} inputType
 * @param {?} input
 * @return {?}
 */
public handleInput(inputType: 'phone' | 'pin', input: any): void {
    const /** @type {?} */ inputValue = input.target.value;
    const /** @type {?} */ errorMessage = {
      pinRequired: ERROR_AUTHENTICATION_MESSAGES.requiredPIN,
      phoneRequired: ERROR_AUTHENTICATION_MESSAGES.requiredPhoneNumber,
      numericalOnly: ERROR_AUTHENTICATION_MESSAGES.numericalInputOnly,
      invalidPin: ERROR_AUTHENTICATION_MESSAGES.invalidPIN,
    };
    const /** @type {?} */ numericalOnly = /^\d+$/;
    const /** @type {?} */ isNumericalOnly = numericalOnly.test(inputValue);
    const /** @type {?} */ isKTPSixteenDigit = inputValue.length === 16;
    const /** @type {?} */ isFirstStep = inputType === INPUT_TYPE.phone;

    this.setSubmitValidation(false, '');
    this.inputError[`${inputType}`] = '';

    if (!inputValue) {
      this.inputError[`${inputType}`] = errorMessage[`${inputType}Required`];
    } else if (inputValue && !isNumericalOnly) {
      this.inputError[`${inputType}`] = errorMessage.numericalOnly;
    } else if (!isFirstStep && !isKTPSixteenDigit) {
      this.inputError.pin = errorMessage.invalidPin;
    }
  }
/**
 * @return {?}
 */
public submitPhoneNumber(): void {
    this.isBusy = true;

    const /** @type {?} */ phoneNumber = this.transformPhoneNumber(this.loginData.phone);
    this.setSubmitValidation(false, '');
    this.verifyPhoneNumber(phoneNumber);
  }
/**
 * @return {?}
 */
public submitKTP(): void {
    this.isBusy = true;

    const /** @type {?} */ isLogin = this.type === AUTH_TYPE.login;
    const /** @type {?} */ isValidKTP = !this.inputError.pin && this.loginData.pin;

    if (!isLogin) {
      this.handleKTPTypeOTP();
    } else if (isValidKTP && isLogin) {
      this.handleKTPTypeLogin();
    } else {
      this.isBusy = false;
      this.inputError.pin = ERROR_AUTHENTICATION_MESSAGES.requiredPIN;
    }
  }
/**
 * @return {?}
 */
public submitOTP(): void {
    this.isBusy = true;

    const /** @type {?} */ isOTPComplete: boolean = this.checkOTPComplete();

    if (isOTPComplete) {
      this.sendOTP();
    } else {
      this.isBusy = false;
      this.setSubmitValidation(
        true,
        ERROR_AUTHENTICATION_MESSAGES.requiredOTPCode,
      );
    }
  }
/**
 * @return {?}
 */
public resendVerificationCode(): void {
    if (!this.isVerificationSent) {
      const /** @type {?} */ isKTPExist = this.submitData.identifier;
      const /** @type {?} */ isLogin = this.type === AUTH_TYPE.login;

      this.isVerificationSent = true;

      if (!isKTPExist && isLogin) {
        this.submitPhoneNumber();
      } else {
        this.submitKTP();
      }
    }
  }
/**
 * @return {?}
 */
public checkOTPComplete(): boolean {
    const /** @type {?} */ otp: string = this.getCombinedOTP();

    return otp.length === 4 ? true : false;
  }
/**
 * @param {?} nextId
 * @param {?} input
 * @return {?}
 */
public OTPInputTab(
    nextId: 'otp_1' | 'otp_2' | 'otp_3' | 'otp_4',
    input: any,
  ): void {
    const /** @type {?} */ isDeleteContent = input.inputType === 'deleteContentBackward';
    const /** @type {?} */ inputLength = input.target.value.length;
    const /** @type {?} */ isInputTargetBiggerThanMaxLength =
      inputLength > input.target.maxLength;

    if (!isDeleteContent) {
      if (isInputTargetBiggerThanMaxLength) {
        const /** @type {?} */ value = input.target.value.substr(inputLength);

        input.target.value = null;
        input.target.value = value;
      }
      this.setFocusOnOTPInputField(nextId);
    }
  }
/**
 * @param {?} nextId
 * @param {?} input
 * @return {?}
 */
public OTPBackspaceTab(
    nextId: 'otp_1' | 'otp_2' | 'otp_3' | 'otp_4',
    input: any,
  ): void {
    input.target.value = null;

    setTimeout(() => {
      this.setFocusOnOTPInputField(nextId);
    }, 50);
  }
/**
 * @param {?} display
 * @param {?} text
 * @return {?}
 */
private setSubmitValidation(display: boolean, text: string): void {
    const /** @type {?} */ displayMessage = {
      display: display,
      msg: text,
    };

    this.submitValidation = displayMessage;
  }
/**
 * @param {?} obj
 * @return {?}
 */
private setSubmitData(obj: any): void {
    this.submitData = { ...this.submitData, ...obj };
  }
/**
 * @param {?} phoneNumber
 * @return {?}
 */
private transformPhoneNumber(phoneNumber: string): string {
    let /** @type {?} */ transformedPhoneNumber;
    const /** @type {?} */ phoneNumberBeginWithZero = phoneNumber.substr(0, 1) === '0';
    const /** @type {?} */ phoneNumberBeginWithAreaCode = phoneNumber.substr(0, 2) === '62';

    if (phoneNumberBeginWithZero) {
      transformedPhoneNumber = phoneNumber.substr(1, phoneNumber.length - 1);
    } else if (phoneNumberBeginWithAreaCode) {
      transformedPhoneNumber = phoneNumber.substr(2, phoneNumber.length - 1);
    } else {
      transformedPhoneNumber = phoneNumber;
    }

    transformedPhoneNumber = `+62${transformedPhoneNumber}`;

    return transformedPhoneNumber;
  }
/**
 * @param {?} phoneNumber
 * @return {?}
 */
private verifyPhoneNumber(phoneNumber: string): void {
    this.isLoginLimitExceeded = false;

    const /** @type {?} */ reqData = {
      phone: phoneNumber,
    };

    this.authService.postLogin(reqData).subscribe(
      (data: any) => {
        this.isBusy = false;
        this.isDisableButton = false;

        if (typeof data.result['tokenId'] !== 'undefined') {
          this.step = 3;

          this.setSubmitData({
            tokenId: data.result.tokenId,
            phone: phoneNumber,
          });

          this.showCountDown();
        } else {
          this.handleLoginError(data.result.code);
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status >= 400 && err.status < 500) {
          const /** @type {?} */ data = err.error;
          this.isBusy = false;
          this.isVerificationSent = false;

          this.handleLoginError(data.result['code'], phoneNumber);
        } else if (err.status === 500) {
          this.isBusy = false;

          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.experiencingProblem,
          );
        } else {
          this.isBusy = false;

          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.defaultMessage,
          );
        }
      },
    );
  }
/**
 * @return {?}
 */
private handleKTPTypeOTP(): void {
    this.setSubmitValidation(false, '');

    if (!Cookies.get(TNK_OTP_SENDED)) {
      Cookies.set(TNK_OTP_SENDED, true);
    }

    const /** @type {?} */ reqData = {
      phone: this.userSuccessData.phoneNumber,
      identifier: this.userSuccessData.ktp,
      tokenId: '',
    };

    this.authService.postLogin(reqData).subscribe(
      (data: any) => {
        if (typeof data.result.tokenId !== 'undefined') {
          reqData.tokenId = data.result.tokenId;
          this.setSubmitData(reqData);

          this.isBusy = false;
          this.isVerificationSent = false;
        } else {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.busyServer,
          );
        }
      },
      (err: HttpErrorResponse) => {
        this.isBusy = false;
        this.isVerificationSent = false;

        if (err.status === 500) {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.experiencingProblem,
          );
        } else {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.busyServer,
          );
        }
      },
    );
  }
/**
 * @return {?}
 */
private handleKTPTypeLogin(): void {
    this.setSubmitValidation(false, '');
    this.isLoginLimitExceeded = false;

    const /** @type {?} */ reqData = {
      phone: this.submitData.phone,
      identifier: this.loginData.pin,
    };

    this.authService.postLogin(reqData).subscribe(
      (data: any) => {
        this.isBusy = false;
        this.isDisableButton = false;
        this.isVerificationSent = true;

        if (typeof data.result.tokenId !== 'undefined') {
          this.step = 3;
          this.setSubmitData({
            identifier: this.loginData.pin,
            tokenId: data.result.tokenId,
          });

          this.showCountDown();
        } else {
          this.handleLoginError(data.result.code);
        }
      },
      (err: HttpErrorResponse) => {
        this.isBusy = false;
        this.isVerificationSent = false;

        const /** @type {?} */ data = err.error;

        if (err.status === 500) {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.experiencingProblem,
          );
        } else if (data.result.code === 1000) {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.noIdentifyPIN,
          );
        } else {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.busyServer,
          );
        }
      },
    );
  }
/**
 * @return {?}
 */
private sendOTP(): void {
    this.setSubmitValidation(false, '');

    const /** @type {?} */ otp = this.getCombinedOTP();

    this.setSubmitData({
      smsToken: otp,
    });

    const /** @type {?} */ reqData = this.submitData;

    this.authService.postLogin(reqData).subscribe(
      (data: any) => {
        this.isVerificationSent = false;

        if (data.message !== 'ERR') {
          Cookies.remove(TNK_OTP_SENDED);
          // set cookies of encrypted token
          Cookies.set(TNK_TOKEN, data.result.token, {
            expires: 365,
          });

          // Exclude user from Push Notification
          this.analyticsService.trackEvent(
            this.analyticsService.addFinishedFormFlag(),
          );

          setTimeout(() => {
            location.href = this.callbackURI;
          }, 500);
        } else {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.busyServer,
          );
        }
      },
      (err: HttpErrorResponse) => {
        this.isBusy = false;

        if (err.status < 500) {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.wrongOTPCode,
          );
        } else if (err.status === 500) {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.experiencingProblem,
          );
        } else {
          this.setSubmitValidation(
            true,
            ERROR_AUTHENTICATION_MESSAGES.defaultMessage,
          );
        }
      },
    );
  }
/**
 * @param {?} errorResultCode
 * @param {?=} phoneNumber
 * @return {?}
 */
private handleLoginError(
    errorResultCode: number,
    phoneNumber?: string,
  ): void {
    const /** @type {?} */ isNotUniquePhoneNumber = errorResultCode === 1122;
    const /** @type {?} */ isExceededLoginLimit = errorResultCode === 1015;

    if (isNotUniquePhoneNumber) {
      this.step = 2;

      this.setSubmitData({
        phone: phoneNumber,
      });
    }

    if (errorResultCode === 1000 || errorResultCode === 1108) {
      this.setSubmitValidation(
        true,
        ERROR_AUTHENTICATION_MESSAGES.phoneNumberNotRegistered,
      );
    }

    if (errorResultCode === 1110) {
      this.setSubmitValidation(true, ERROR_AUTHENTICATION_MESSAGES.busyServer);
    }

    if (isExceededLoginLimit) {
      this.isLoginLimitExceeded = true;

      this.setSubmitValidation(true, ERROR_AUTHENTICATION_MESSAGES.loginlimit);
    }
  }
/**
 * @param {?} id
 * @return {?}
 */
private setFocusOnOTPInputField(
    id: 'otp_1' | 'otp_2' | 'otp_3' | 'otp_4',
  ): void {
    if (id === OTP.otp1) {
      this.otp1Element.nativeElement.focus();
    } else if (id === OTP.otp2) {
      this.otp2Element.nativeElement.focus();
    } else if (id === OTP.otp3) {
      this.otp3Element.nativeElement.focus();
    } else if (id === OTP.otp4) {
      this.otp4Element.nativeElement.focus();
    }
  }
/**
 * @return {?}
 */
private getCombinedOTP(): string {
    const /** @type {?} */ combinedOTP: string = `${this.loginData.otp_1}${this.loginData.otp_2}${this.loginData.otp_3}${this.loginData.otp_4}`;

    return combinedOTP;
  }
/**
 * @return {?}
 */
private showCountDown(): void {
    this.startCountDown(this.countDownTime);
    const /** @type {?} */ delay = this.countDownTime === 60 ? 90 : 120;
    this.countDownTime = delay;
  }
/**
 * @param {?} duration
 * @return {?}
 */
private startCountDown(duration: number): void {
    let /** @type {?} */ timer = duration;
    this.displayCountDown = this.convertSecToMin(timer);

    const /** @type {?} */ interval = setInterval(() => {
      timer--;
      this.displayCountDown = this.convertSecToMin(timer);

      if (timer === 0) {
        this.displayCountDown = '';
        clearInterval(interval);
        this.isVerificationSent = false;
      }
    }, 1000);
    return;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tnk-auth-customer',
  template: `
    <div class="wrapper__login">
      <div class="container__login">
        <ng-container *ngIf="type === 'login'">
          <h2 class="title">Masuk ke Akun Anda</h2>

          <ng-container *ngIf="step == 1">
            <div class="login__block">
              <label>Nomor Handphone</label>
              <div class="from-group" [class.has-error]="inputError.phone">
                <div class="input-group">
                  <span class="input-group-addon">+62</span>
                  <input
                    type="text"
                    class="form-control"
                    id="login_phone"
                    [(ngModel)]="loginData.phone"
                    (input)="handleInput(INPUT_TYPE.phone, $event)"
                  />
                </div>

                <p class="help-block">{{ inputError.phone }}</p>
              </div>
            </div>

            <div class="login__block">
              <button
                class="tnk__button button--lg button--green button--block"
                [disabled]="isBusy"
                id="login_btn_step1"
                (click)="submitPhoneNumber()"
              >
                {{ isBusy ? 'Mohon menunggu...' : 'Masuk' }}
              </button>
              <div class="changephonenumber-block">
                <p
                  class="text-primary"
                  style="text-decoration: underline; cursor: pointer"
                  (click)="changePhoneNumber()"
                >
                  Lupa atau ubah nomor handphone?
                  <i
                    class="fa"
                    [class.fa-chevron-circle-down]="!isChangePhoneNumber"
                    [class.fa-chevron-circle-up]="isChangePhoneNumber"
                    aria-hidden="true"
                  ></i>
                </p>
                <p *ngIf="isChangePhoneNumber">
                  Hubungi
                  <span class="text-primary">02140005859</span>
                  atau
                  <span class="text-primary">02130005859</span>
                  untuk mengganti nomor handphone Anda.
                </p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="step == 2">
            <div class="login__block">
              <label>Nomor KTP</label>

              <div class="form-group" [class.has-error]="inputError.pin">
                <input
                  type="text"
                  class="form-control"
                  id="login_pin"
                  [(ngModel)]="loginData.pin"
                  (input)="handleInput(INPUT_TYPE.pin, $event)"
                />

                <p class="help-block">{{ inputError.pin }}</p>
              </div>
            </div>

            <div class="login__block">
              <button
                class="tnk__button button--lg button--green button--block"
                [disabled]="isBusy"
                (click)="submitKTP()"
                id="login_btn_step2"
              >
                {{ isBusy ? 'Mohon menunggu...' : 'Masuk' }}
              </button>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="step == 3">
          <label class="tnk-margin-bottom--large label__title">
            Kode Verifikasi
          </label>
          <p *ngIf="type === 'login'" class="description">
            Kode akses telah terkirim via SMS ke nomor handphone Anda, silakan
            masukkan kode ke kolom di bawah ini
          </p>

          <div class="login__block">
            <div class="row">
              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  maxlength="1"
                  #otp_1
                  id="login_otp1"
                  [(ngModel)]="loginData.otp_1"
                  (input)="OTPInputTab('otp_2', $event)"
                  (keypress)="numericalInputOnly($event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>

              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  #otp_2
                  maxlength="1"
                  id="login_otp2"
                  [(ngModel)]="loginData.otp_2"
                  (input)="OTPInputTab('otp_3', $event)"
                  (keypress)="numericalInputOnly($event)"
                  (keydown.backspace)="OTPBackspaceTab('otp_1', $event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>

              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  #otp_3
                  maxlength="1"
                  id="login_otp3"
                  [(ngModel)]="loginData.otp_3"
                  (input)="OTPInputTab('otp_4', $event)"
                  (keypress)="numericalInputOnly($event)"
                  (keydown.backspace)="OTPBackspaceTab('otp_2', $event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>

              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  #otp_4
                  maxlength="1"
                  id="login_otp4"
                  [(ngModel)]="loginData.otp_4"
                  (input)="OTPInputTab(null, $event)"
                  (keypress)="numericalInputOnly($event)"
                  (keydown.backspace)="OTPBackspaceTab('otp_3', $event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>
            </div>
          </div>
          <div class="login__block">
            <button
              class="tnk__button button--lg button--green button--block"
              (click)="submitOTP()"
              id="login_btn_step3"
            >
              {{ isBusy ? 'Mohon menunggu...' : 'Masuk ke Akun' }}
            </button>
            <ng-container *ngIf="!isLoginLimitExceeded">
              <p
                id="pinjamlagi_KirimUlangKode"
                class="description description--center"
                *ngIf="!isVerificationSent"
              >
                Belum menerima kode?
                <a
                  href="javascript:void(0)"
                  (click)="resendVerificationCode()"
                  id="login_link_resendverification"
                >
                  Kirim ulang kode
                </a>
              </p>

              <p class="description description--center" *ngIf="isBusy">
                Kode akses sedang dikirim, mohon menunggu
              </p>

              <p
                class="description description--center"
                *ngIf="!isBusy && isVerificationSent"
              >
                Masa Aktif OTP {{ displayCountDown }}
              </p>
            </ng-container>
          </div>
        </ng-container>

        <div class="login__block" *ngIf="step != 3 && !submitValidation.display">
          <div class="block__info">
            <p>
              Untuk keamanan data Anda, pastikan ikon
              <span class="icon fa fa-lock"></span>
              tampil di halaman URL Tunaiku
            </p>
          </div>
        </div>

        <div class="login__block" *ngIf="submitValidation.display">
          <div class="block__info error--block">
            <p>{{ submitValidation.msg }}</p>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .pd-left-right-20 {
      padding-left: 20px;
      padding-right: 20px;
    }
    .separator {
      position: relative;
      width: 100%;
      height: 1px;
      display: block;
      overflow: hidden;
      background-color: #ececec;
      margin: 5px auto;
    }
    .separator:after {
      content: ' ';
    }
    .table.table--borderless td,
    .table.table--borderless th {
      border: none;
    }
    .table.table--borderless td {
      font-size: 14px;
    }
    .separator {
      position: relative;
      display: block;
      height: 1px;
      width: 100%;
      background-color: #ccc;
      margin-bottom: 10px;
    }
    .no--margin {
      margin: 0 !important;
    }
    a.link {
      -webkit-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
    }
    a.link.link--clr-blue:link {
      color: #004c7b;
    }
    .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group {
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
    }
    .form-wrapper .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group .help-block {
      font-size: 13px;
    }
    .form-wrapper .form-group .help-block.label--control {
      color: #444;
    }
    .form-wrapper .form-group .col-sm-* p {
      margin-bottom: 15px;
    }
    a.tnk__button {
      text-decoration: none;
    }
    .tnk__button {
      position: relative;
      display: inline-block;
      min-width: 70px;
      padding: 10px;
      -webkit-appearance: none;
         -moz-appearance: none;
              appearance: none;
      outline: 0;
      cursor: pointer;
      border: 1px solid transparent;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin: 0 auto;
      border-radius: 35px;
      -webkit-box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
              box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
      text-transform: uppercase;
      margin-top: 15px;
    }
    .tnk__button[disabled] {
      cursor: not-allowed;
    }
    .tnk__button.button--sm {
      font-size: 12px;
    }
    .tnk__button.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
    }
    .tnk__button.button--block {
      min-width: 100%;
      width: 100%;
      padding: 10px 0;
    }
    .tnk__button.button--float-right {
      float: right;
      margin-right: 10px;
    }
    .tnk__button.button--float-left {
      float: left;
      margin-left: 10px;
    }
    .tnk__button.button--min {
      width: 110px;
      padding: 10px 5px;
      margin-bottom: 5px;
    }
    .tnk__button.button--green {
      font-size: 12px;
      color: #fff;
      background-color: #81be41;
    }
    .tnk__button.button--green.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--green:hover {
      background-color: #72b63e;
    }
    .tnk__button.button--green:active {
      color: #f2f2f2;
      bakground-color: #6ab631;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--green[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--green.button--sm {
      -webkit-box-shadow: none;
              box-shadow: none;
      padding: 8.5px 10px;
    }
    .tnk__button.button--blue {
      background-color: #1a72a4;
      color: #fff;
      font-size: 12px;
    }
    .tnk__button.button--blue.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--blue:hover {
      background-color: #1e6a94;
      color: #fff;
    }
    .tnk__button.button--blue:active {
      color: #f2f2f2;
      background-color: #004c7b;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--blue[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--blue.button--min {
      font-size: 10px;
    }
    .tnk__button.button--red {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole {
      border-radius: 16.5px;
      padding: 7px 10px;
    }
    .tnk__button.button--hole.button--red {
      background-color: #fff;
      border: 2px solid #721c24;
      color: #721c24;
    }
    .tnk__button.button--hole.button--red:hover,
    .tnk__button.button--hole.button--red :active {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole.button--green {
      background-color: transparent;
      border: 2px solid #81be41;
      color: #81be41;
    }
    .tnk__button.button--hole.button--green.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--green.button--active {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--green.button--active:hover,
    .tnk__button.button--hole.button--green.button--active :active {
      background-color: #6ab631;
    }
    .tnk__button.button--hole.button--green:hover {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue {
      background-color: transparent;
      border: 2px solid #1a72a4;
      color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--blue.button--active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue.button--active:hover,
    .tnk__button.button--hole.button--blue.button--active :active {
      background-color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue:hover,
    .tnk__button.button--hole.button--blue :active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue[disabled] {
      border: 2px solid transparent;
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--margin-sm {
      margin-top: 5px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button.button--margin-md {
      margin-top: 10px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button .icon {
      margin-right: 10px;
    }
    .tnk__modal {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5000;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background-color: rgba(0,0,0,0.75);
    }
    .tnk__modal .modal__inner {
      position: relative;
      border-radius: 8px;
      background-color: #fff;
      -webkit-box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
              box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
      width: 80%;
      min-height: 240px;
      margin: 7.5% auto 0;
      display: block;
    }
    .tnk__modal .modal__inner.modal--size-small {
      width: 30%;
      border-radius: 8px;
      min-height: 120px;
      margin: 0 auto;
    }
    .tnk__modal .modal__inner.modal--size-small .modal__content {
      margin-top: 25vh;
      padding: 30px;
    }
    .tnk__modal .modal__inner .modal__content {
      position: relative;
      display: block;
      overflow: hidden;
    }
    .tnk__modal .modal__inner .modal__content.content--align-center {
      text-align: center;
    }
    .tnk__modal .modal__inner .modal__content h4 {
      font-size: 22px;
      color: #81be41;
    }
    .tnk__modal .modal__inner .modal__content .head__icon {
      font-size: 48px;
    }
    .tnk__modal .modal__inner .modal__content p {
      color: #8a8989;
      margin-top: 28px;
    }
    .checkbox__wrapper {
      position: relative;
      display: block;
      overflow: hidden;
      background-color: #cfe6f0;
      padding: 20px 30px;
      border-radius: 5px;
      margin: 0 0 10px;
    }
    .checkbox__wrapper.has-error {
      background-color: #f2dede;
    }
    .checkbox__wrapper.has-error p {
      color: #721c24;
    }
    .checkbox__wrapper label {
      color: #191919;
    }
    .checkbox__wrapper label input[type=checkbox] {
      width: 16px;
      height: 16px;
      margin-left: -25px;
      margin-top: 3px;
    }
    .birth__province {
      padding-left: 0 !important;
    }
    .birth__city {
      padding-right: 0 !important;
    }
    @media screen and (min-width: 240px) and (max-width: 800px) {
      .birth__province {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .birth__city {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .tnk__button.button--margin-sm {
        min-width: 42.5%;
      }
      .tnk__button.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--hole.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--float-left {
        margin-left: 0;
      }
      .tnk__modal .modal__inner.modal--size-small {
        width: 100%;
        border-radius: 0;
        min-height: 100vh;
      }
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        margin-top: 0;
        padding: 0;
        padding-top: 25vh;
      }
    }
    @media screen and (max-width: 1024px) {
      .tnk__button.button--hole.button--green:active {
        background-color: #81be41;
        color: #fff;
      }
    }
    @media screen and (min-width: 1024px) {
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        padding-top: 25;
      }
      .checkbox__wrapper {
        margin: 0 0 10px;
      }
    }
    .wrapper__login {
      position: relative;
      background-color: #f8f8f8;
      -webkit-box-shadow: 0px 2px 4.8px 0.3px rgba(65,65,65,0.15);
              box-shadow: 0px 2px 4.8px 0.3px rgba(65,65,65,0.15);
      border: solid 1px #e1e1e1;
      margin: 10px;
      display: block;
    }
    .wrapper__login .container__login {
      position: relative;
      display: block;
      padding: 36px;
      overflow: hidden;
    }
    .wrapper__login .title {
      font-size: 21px;
      font-weight: bold;
      margin-bottom: 35px;
    }
    .wrapper__login .description {
      font-size: 12.6px;
      line-height: 1.5em;
    }
    .wrapper__login .description--center {
      text-align: center;
    }
    .wrapper__login .label__title {
      text-align: center;
      font-size: 1.4em;
    }
    .wrapper__login .login__block {
      position: relative;
      width: 100%;
      display: block;
      margin-bottom: 15px;
    }
    .wrapper__login .login__block .input-group {
      width: 100%;
      margin-top: 18px;
    }
    .wrapper__login .login__block .tnk__button {
      margin-top: 30px;
      margin-bottom: 26px;
    }
    @media screen and (max-width: 480px) {
      .wrapper__login .login__block .tnk__button {
        margin-top: 20px;
      }
    }
    .wrapper__login .login__block .otp--input {
      height: 83px;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      -moz-appearance: textfield;
    }
    .wrapper__login .login__block .otp--input::-webkit-inner-spin-button,
    .wrapper__login .login__block .otp--input ::-webkit-outer-spin-button {
      -webkit-appearance: none;
              appearance: none;
      -moz-appearance: none;
    }
    .wrapper__login .login__block .changephonenumber-block {
      text-align: center;
    }
    .wrapper__login .login__block .col-sm-3 {
      padding-right: 10px;
      padding-left: 10px;
    }
    .wrapper__login .login__block .help-block {
      font-size: 12.1px;
    }
    .wrapper__login .block__info {
      position: relative;
      display: block;
      width: 90%;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid #e1e1e1;
      padding: 10px;
    }
    .wrapper__login .block__info p {
      font-size: 12.1px;
      text-align: justify;
      line-height: 1.5em;
    }
    .wrapper__login .block__info .icon {
      color: #008d45;
    }
    .wrapper__login .block__info.error--block {
      border: 1px solid #f00;
      padding: 20px;
    }
    .wrapper__login .block__info.error--block p {
      color: #f00;
    }
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AnalyticsService, },
{type: AuthCustomerService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'step': [{ type: Input, args: ['step', ] },],
'callbackURI': [{ type: Input, args: ['callbackURI', ] },],
'type': [{ type: Input, args: ['type', ] },],
'phoneNumber': [{ type: Output },],
'otp1Element': [{ type: ViewChild, args: ['otp_1', ] },],
'otp2Element': [{ type: ViewChild, args: ['otp_2', ] },],
'otp3Element': [{ type: ViewChild, args: ['otp_3', ] },],
'otp4Element': [{ type: ViewChild, args: ['otp_4', ] },],
};
}

function TNKAuthCustomerComponent_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthCustomerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthCustomerComponent.ctorParameters;
/** @type {?} */
TNKAuthCustomerComponent.propDecorators;
/** @type {?} */
TNKAuthCustomerComponent.prototype.step;
/** @type {?} */
TNKAuthCustomerComponent.prototype.callbackURI;
/** @type {?} */
TNKAuthCustomerComponent.prototype.type;
/** @type {?} */
TNKAuthCustomerComponent.prototype.phoneNumber;
/** @type {?} */
TNKAuthCustomerComponent.prototype.otp1Element;
/** @type {?} */
TNKAuthCustomerComponent.prototype.otp2Element;
/** @type {?} */
TNKAuthCustomerComponent.prototype.otp3Element;
/** @type {?} */
TNKAuthCustomerComponent.prototype.otp4Element;
/** @type {?} */
TNKAuthCustomerComponent.prototype.loginData;
/** @type {?} */
TNKAuthCustomerComponent.prototype.submitData;
/** @type {?} */
TNKAuthCustomerComponent.prototype.inputError;
/** @type {?} */
TNKAuthCustomerComponent.prototype.userSuccessData;
/** @type {?} */
TNKAuthCustomerComponent.prototype.submitValidation;
/** @type {?} */
TNKAuthCustomerComponent.prototype.isBusy;
/** @type {?} */
TNKAuthCustomerComponent.prototype.isVerificationSent;
/** @type {?} */
TNKAuthCustomerComponent.prototype.isChangePhoneNumber;
/** @type {?} */
TNKAuthCustomerComponent.prototype.isDisableButton;
/** @type {?} */
TNKAuthCustomerComponent.prototype.isLoginLimitExceeded;
/** @type {?} */
TNKAuthCustomerComponent.prototype.numericalInputOnly;
/** @type {?} */
TNKAuthCustomerComponent.prototype.convertSecToMin;
/** @type {?} */
TNKAuthCustomerComponent.prototype.INPUT_TYPE;
/** @type {?} */
TNKAuthCustomerComponent.prototype.displayCountDown;
/** @type {?} */
TNKAuthCustomerComponent.prototype.countDownTime;
/** @type {?} */
TNKAuthCustomerComponent.prototype.analyticsService;
/** @type {?} */
TNKAuthCustomerComponent.prototype.authService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
